export default "__VITE_ASSET__C$AZgdGE__"